
'use strict';
import $ from 'jquery';

const ajaxInjection = require('./../modules/ajaxInjector.js');

$('.add-to-favorites').on('click', function() {
    let data = {
        'productid': $(this).data('productid')
    };

    ajaxInjection.request(
        '/ajax/favorite/add',
        'POST',
        data,
        '.form_output',
        require('./../template/customer/form.hbs')
    )
        .then(response => {
            $(this).after('<span class="success">'+ response.message +'</span>');
            $(this).remove();
        });
});

$('body').on('click', '.delete-favorites', function(event) {
    event.preventDefault();
    let data = {};

    data.id = $(this).data('id');

    ajaxInjection.request(
        '/ajax/favorite/delete',
        'POST',
        data,
    ).then(() => {
        window.location.reload();
    });

});
